module.exports = __webpack_public_path__ + "img/CNFN-icon.603fbd8c.png";